'use strict';

// Static Methods
require('./escape');

// Instance Methods
require('./addFlags');
require('./getFlags');
require('./removeFlags');
require('./setFlags');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/regexp/index.js
// module id = 1174
// module chunks = 1